<template>
    <v-combobox 
        v-model='childData'
        :label='label'
        :rules='rules'
        :items='items'
        :disabled='disabled'
        item-text='name'
        clearable
    ></v-combobox>
</template>
<script>
//import CommonDataService from '../services/CommonDataService'
import ComboBoxUtil from '../utils/ComboBoxUtil'
export default {
    name: "insurance-company-combo",
    props: {
        value: Object,
        label: String,
        rules: Array,
        items: Array,
        disabled: Boolean,
    },
    data(){
        return {
            childData: this.value,
            //items:[],
            nonceCount:0,
            result:null
        }
    },
    created() {
        /*
        CommonDataService.findInsuranceCompanies().then((response)=>{
                console.log(response)
                this.result = response
                this.items = response.data.list
                this.nonceCount = this.items.length
            }).catch(function (error) {
                console.log(error)
            })
        */
    },
    watch:{
        value(val){
            this.childData = ComboBoxUtil.getComboBoxModel(val,this.items,{id:-1, name:'', insurance_products:[]})
        },
        childData(val){
            this.$emit('input', ComboBoxUtil.getComboBoxModel(val,this.items,{id:-1, name:'', insurance_products:[]}))
        }
    },
    methods:{
        filter(item, queryText, itemText){
            const hasValue = val => val != null ? val : '' //建立內部函式hasValue，把val用=>指到一個函式，利用三元判斷val的值。
            const text = hasValue(itemText) //呼叫內部函式
            const query = hasValue(queryText)
            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1
        }
    }
}
</script>
